import { render, staticRenderFns } from "./masterdata-form.vue?vue&type=template&id=b12f28fe&lang=pug"
import script from "./masterdata-form.vue?vue&type=script&lang=ts"
export * from "./masterdata-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports